import { ArchivedDocument } from "./ArchivedDocument";

export type ArchivedDocumentContent = {
    content: ArchivedDocument;
};
